import { useEffect, useState } from 'react';

function computeInset(): number {
  if (typeof window === 'undefined' || !window.visualViewport) return 0;
  const vv = window.visualViewport;
  return Math.max(0, Math.round(window.innerHeight - (vv.height + vv.offsetTop)));
}

/** Height (px) covered at the bottom of the layout viewport, e.g. by the on-screen keyboard. */
export function useVisualViewportInset(): number {
  const [inset, setInset] = useState(computeInset);

  useEffect(() => {
    const vv = typeof window !== 'undefined' ? window.visualViewport : null;
    if (!vv) return;
    const update = () => setInset(computeInset());
    update();
    vv.addEventListener('resize', update);
    vv.addEventListener('scroll', update);
    return () => {
      vv.removeEventListener('resize', update);
      vv.removeEventListener('scroll', update);
    };
  }, []);

  return inset;
}
